export function initializeLayer(layer) {
  return {
    type: null,
    id: null,
    name: null,
    props: {},
    ...layer,
  }
}
